import React, { Component } from 'react';
import ReactTable from 'react-table';
import { UncontrolledTooltip } from 'reactstrap';
import DownloadIcon from '../../Icons/DownloadIcon';
import ResetFilterIcon from '../../Icons/ResetFilterIcon';
import SpinnerIcon from '../../Icons/SpinnerIcon';
const maxCsvRows = 5000;
export default class WmReactTableServerSide extends Component {
  constructor(props) {
    super(props);
    this.resetFilter = () => this.props.resetFilters === undefined ? '' : /*#__PURE__*/React.createElement(ResetFilterIcon, {
      onClick: this.props.resetFilters
    });
    this.csvButton = () => {
      let content = '';
      if (this.props.currentlyDownloading === true) {
        content = /*#__PURE__*/React.createElement(SpinnerIcon, null);
      } else if (this.props.canDownloadCsv === true) {
        if (this.maxRows() > maxCsvRows) {
          // TODO: Translate
          content = this.disabledDownload("Must filter to less than ".concat(maxCsvRows, " records to download"));
        } else if (this.props.data.length === 0) {
          // TODO: Translate
          content = this.disabledDownload('No records are available to download');
        } else {
          content = /*#__PURE__*/React.createElement(DownloadIcon, {
            onClick: this.props.downloadCsv
          });
        }
      }
      return content;
    };
    this.disabledDownload = msg => /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      id: "downloadIcon"
    }, /*#__PURE__*/React.createElement(DownloadIcon, {
      disabled: true
    })), /*#__PURE__*/React.createElement(UncontrolledTooltip, {
      placement: "right",
      target: "downloadIcon"
    }, msg));
    this.maxRows = () => {
      const perPage = ((this.props.innerRef.current || {}).state || {}).pageSize || 0;
      return perPage * (this.props.pages || 0);
    };
    // TODO: Translate
    this.noDataText = () => this.props.noDataText ? /*#__PURE__*/React.createElement("div", {
      className: "red"
    }, this.props.noDataText) : 'No rows found';
    this.state = {
      filtered: props.filtered,
      sorted: props.sorted
    };
  }
  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, this.resetFilter(), "\xA0\xA0\xA0", this.csvButton()), /*#__PURE__*/React.createElement(ReactTable, {
      manual: true,
      showPagination: true,
      filterable: true,
      ref: this.props.innerRef,
      className: "-striped -highlight ".concat(this.props.className),
      minRows: 3,
      pageSizeOptions: this.props.pageSizeOptions || [5, 10, 20, 25, 50, 100, 150, 200],
      data: this.props.data,
      loading: this.props.loading,
      columns: this.props.columns,
      onFetchData: this.props.onFetchData,
      pages: this.props.pages,
      noDataText: this.noDataText(),
      defaultSorted: this.state.sorted,
      filtered: this.state.filtered,
      onFilteredChange: filtered => {
        this.setState({
          filtered
        });
        if (this.props.onFilteredChange !== undefined) {
          this.props.onFilteredChange(filtered);
        }
      },
      getTrProps: this.props.getTrProps,
      style: this.props.tableStyle
    }));
  }
}